import _uniqBy from "lodash/uniqBy";
import _forEach from "lodash/forEach";
import _toUpper from "lodash/toUpper";
import _includes from "lodash/includes";

const featuredProducts = ["eld", "dvir", "workOrder", "logbook"];

/**
 * Create a list of available products.
 *
 * @param {Object} products Coming from `myAccount` features
 * @return void
 */
export function setProduct(products) {
    const setState = Vistracks.Scope.AppState.attr("products");
    const productSize = Object.keys(products).length;
    const ELD = "ELD" in products || "LOGBOOK" in products;
    const DVIR = "DVIR" in products;
    const LOGBOOK = "LOGBOOK" in products;
    const WORK_ORDER = "Work Orders" in products;
    const ELD_LOGBOOK = "ELD" in products && "LOGBOOK" in products;

    // Set products state to its original
    setState.attr("hosOnly", false);
    setState.attr("dvirOnly", false);
    setState.attr("hosAndDvir", false);
    setState.attr("mobileWorkerOnly", false);
    setState.attr("hosAndMobileWorker", false);
    setState.attr("dvirAndMobileWorker", false);
    setState.attr("hosDvirAndMobileWorker", false);

    if (productSize === 1) {
        if (ELD) {
            setState.attr("hosOnly", true);
        } else if (DVIR) {
            setState.attr("dvirOnly", true);
        } else if (WORK_ORDER) {
            setState.attr("mobileWorkerOnly", true);
        }

        return false;
    }

    if (productSize === 2) {
        if (ELD_LOGBOOK) {
            setState.attr("hosOnly", true);
        } else if (ELD && DVIR) {
            setState.attr("hosAndDvir", true);
        } else if (ELD && WORK_ORDER) {
            setState.attr("hosAndMobileWorker", true);
        } else if (DVIR && WORK_ORDER) {
            setState.attr("dvirAndMobileWorker", true);
        }

        return false;
    }

    if (productSize >= 3) {
        if (ELD && DVIR && WORK_ORDER) {
            setState.attr("hosDvirAndMobileWorker", true);
        } else if (ELD_LOGBOOK && WORK_ORDER) {
            setState.attr("hosAndMobileWorker", true);
        } else if (ELD_LOGBOOK && DVIR) {
            setState.attr("hosAndDvir", true);
        }

        return false;
    }
}

/**
 * Returns a list of available products base on `myAccount` features.
 *
 * @param {Object} products Coming from `myAccount` features
 * @return {Array}  Collection
 */
export function getAvailableProducts(products) {
    "use strict";

    const _products = Object.keys(products);
    const availableProducts = [];

    _forEach(_products, (product, index) => {
        const inFeaturedProducts = _includes(featuredProducts, product);

        if (inFeaturedProducts && products[product]) {
            const name = product === "workOrder" ? "Work Orders" : _toUpper(product);
            const featureName = name === "Work Orders" ? "WORK_ORDER" : name;
            const Alias = name === 'ELD' || name === 'LOGBOOK' ? "RODS/HOS" : name;

            availableProducts.push({
                key: index,
                name,
                featureName: name === 'LOGBOOK' ? 'ELD' : featureName,
                isChecked: false,
                Alias: Alias
            })
        }
    });

    return _uniqBy(availableProducts, 'featureName');
}